module.exports = __webpack_public_path__ + "static/media/train.9d49a159.svg";